import { storageRef } from '../../firebase/firebaseSetup';
import { query, getDocs, where, Query } from 'firebase/firestore';
import {
    ref,
    uploadBytes,
    UploadResult,
    getDownloadURL,
    SettableMetadata
} from 'firebase/storage';

import AbstractService from '../abstract/abstractService';
import { UserClass, UserInterface } from './';
import ErrorInterface from '../interfaces/errorInterface';

export const identifier = 'users';

export default class UserService extends AbstractService<UserClass> {
    constructor() {
        super(identifier, UserClass);
    }

    private getResult = async (query: Query): Promise<UserClass[]> => {
        const querySnapshot = await getDocs(query);
        const results: UserClass[] = querySnapshot.docs.map((item) => {
            return new UserClass({
                id: item.id,
                ...item.data()
            } as UserInterface);
        });
        return results as UserClass[];
    };

    getProfilesById = (Ids: string[]): Promise<UserClass[]> => {
        const q = query(
            this.queryCollection,
            where('id', 'in', Ids),
            where('public', '==', true)
        );
        return this.getResult(q);
    };

    getPublicProfiles = (): Promise<UserClass[]> => {
        const q = query(this.queryCollection, where('public', '==', true));
        return this.getResult(q);
    };

    uploadProfilePicture = async (
        file: File,
        user: UserClass,
        metadata?: SettableMetadata
    ): Promise<UserClass | ErrorInterface> => {
        try {
            const reference = ref(
                storageRef.root,
                `${this.collectionId}/${user.id}/${Date.now()}_${file.name}`
            );
            const blob = (await uploadBytes(
                reference,
                file,
                metadata
            )) as UploadResult;

            const url = (await getDownloadURL(blob.ref)) as string;
            user.image = url;

            const saved = await this.save(user);
            return saved as UserClass;
        } catch (e: any) {
            console.error(e);
            return {
                error: true,
                errorMsg: e.message
            } as ErrorInterface;
        }
    };
}
